import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMarkerTick = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 42,
	height: 42,
	viewBox: "0 0 42 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.5 28L8.75 19.25L11.2175 16.765L17.5 23.0475L30.7825 9.765L33.25 12.25M33.25 1.75H8.75C6.8075 1.75 5.25 3.3075 5.25 5.25V27.8775C5.25 29.085 5.8625 30.1525 6.79 30.7825L21 40.25L35.1925 30.7825C36.12 30.1525 36.75 29.085 36.75 27.8775V5.25C36.75 4.32174 36.3813 3.4315 35.7249 2.77513C35.0685 2.11875 34.1783 1.75 33.25 1.75Z",
		fill: "#357DED"
	})
});
export default SvgMarkerTick;
